import collapsibleItem from "./components/collapsibleItem.vue"
import sliderAndInput from "./components/sliderAndInput.vue"
import doubleInput from "./components/doubleInput.vue"
import singleInput from "./components/singleInput.vue"
import textSetting from "./components/textSetting.vue"
import textSettingUpdate from "./components/textSetting_update.vue"
import textSettingComplex from "./components/textSettingComplex.vue"
import textSettingComplexUpdate from "./components/textSettingComplex_update.vue"
import textVerticalAlignSetting from "./components/textVerticalAlignSetting.vue"
import textAlignSetting from "./components/textAlignSetting.vue"
import imgUpload from "./components/imgUpload.vue"
import imgIconUpload from "./components/imgIconUpload.vue"
import imgUploadSimple from "./components/imgUploadSimple.vue"
import colorPicker from "./components/colorPicker.vue"
import colorPickerThemeColor from "./components/colorPickerThemeColor.vue"
import boxShadow from "./components/boxShadow.vue"
import imgCrop from "./components/imgCrop.vue"
import imgCropBg from "./components/imgCropBg.vue"
import lineSetting from "./components/lineSetting.vue"
import cxCheckBox from "./components/cxCheckBox.vue"
import cxSelect from "./components/cxSelect.vue"
import cxBorder from "./components/cxBorder.vue"
import cxBgColor from "./components/colorPicker/bgColor.vue"
import cxBackground from "./components/cxBackground.vue"
import chartColorSetting from "./components/chartColorSetting.vue"
import editTable from "./components/editTable/editTable.vue"
import linkSet from "./components/linkSet.vue"
import borderRadius from "./components/borderRadius.vue"
import cxPadding from "./components/cxPadding.vue"
import cxIcon from "./components/cxIcon.vue"
import cxTooltip from "./components/cxTooltip.vue"
import cxColorPicker from "./components/cxColorPicker.vue"
import cxBaseColor from "./components/colorPicker/baseColor.vue"
import paginationSet from "./components/paginationSet.vue"
import cxSlider from "./components/cxSlider.vue"
import cxTabsIcon from "./components/cxTabsIcon.vue"
import cxDrawer from "./components/cxDrawer/cxDrawer.vue"
import cxCursor from "./components/cxCursor.vue"
import colorSelector from "./components/colorSelector.vue"
import fontColorSelector from "./components/fontColorSelector.vue"
import cxLabelSlider from "./components/cxLabelSlider.vue"
import quickFontSize from "./components/quickFontSize.vue"
import cxPopover from "./components/cxPopover/index.vue"
const cxUI = {}

const COMPONENTS = [
  collapsibleItem,
  sliderAndInput,
  doubleInput,
  singleInput,
  textSetting,
  textSettingUpdate,
  textSettingComplex,
  textSettingComplexUpdate,
  textVerticalAlignSetting,
  textAlignSetting,
  colorPicker,
  imgUpload,
  imgIconUpload,
  imgUploadSimple,
  imgCrop,
  imgCropBg,
  lineSetting,
  cxCheckBox,
  cxSelect,
  colorPickerThemeColor,
  boxShadow,
  cxBorder,
  cxBgColor,
  cxBackground,
  chartColorSetting,
  editTable,
  linkSet,
  borderRadius,
  cxPadding,
  cxIcon,
  cxTooltip,
  cxColorPicker,
  cxBaseColor,
  paginationSet,
  cxSlider,
  cxTabsIcon,
  cxDrawer,
  cxCursor,
  colorSelector,
  fontColorSelector,
  cxCursor,
  cxLabelSlider,
  quickFontSize,
  cxPopover
]

cxUI.install = function (Vue, option) {
  const components = option && option.components
  if (option && components) {
    COMPONENTS.forEach(myComponent => {
      if (components.find(it => it === myComponent.name)) {
        Vue.component(myComponent.name, myComponent)
      }
    })
  } else {
    COMPONENTS.forEach(myComponent => {
      Vue.component(myComponent.name, myComponent)
    })
  }
   // Vue.component("colorPickerThemeColor", cxColorPicker)
}

export default cxUI
